export const SearchIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg
    {...props}
    width={props.width ? props.width : "15px"}
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M6.7775 12.3363C9.57137 12.3363 11.8363 10.0714 11.8363 7.2775C11.8363 4.48363 9.57137 2.21875 6.7775 2.21875C3.98363 2.21875 1.71875 4.48363 1.71875 7.2775C1.71875 10.0714 3.98363 12.3363 6.7775 12.3363Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3535 10.8545L13.2804 13.7814"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
